// assets
import PaymentIcon from '@mui/icons-material/Payment';

// constant


// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const payment = {
    id: 'payment',
    title: '결제',
    type: 'group',
    children: [{
        id: 'Payment',
        title: '결제',
        type: 'item',
        url: 'payment',
        icon: PaymentIcon,
        breadcrumbs: false
    },

    ]


};

export default payment;